import React from "react";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { BfButtonBlue } from "../../../Styling/styledForm/styledBlueForm";

const SelectedExcelSheet = (props) => {

    const asDateForExcel = (val) => {
        if (val !== null && val !== undefined) {
            let splittedDate = val.replace(' ', '-').split('-');
            let splittedDay = splittedDate[2].replace(' ', 'T').split('T');
            let ExcelDate = splittedDay[0] + '.' + splittedDate[1] + '.' + splittedDate[0];
            return ExcelDate
        } else {
            return ''
        }
    }

    const getCurrentDate = () => {
        const currentDate = new Date();
        const day = currentDate.getDate().toString().padStart(2, '0');
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const year = currentDate.getFullYear();
        return `${day}.${month}.${year}`;
    };

    const getFileName = () => `${props.headerState.kreditorName}.xlsx`

    const handleExport = () => {
        const wb = XLSX.utils.book_new();

        const headerRow = [
            props.localeMessages['GHS_customer_ref'],
            props.localeMessages['GHS_measuring_ID'],
            props.localeMessages['GHS_customer_name'],
            props.localeMessages['GHS_utility_address'],
            props.localeMessages['GHS_closing_amount'],
            props.localeMessages['GHS_date_closingList'],
            props.localeMessages['GHS_selected_date'],
        ];
        
        // Må matche rekkefølge til headerRow
        const dataRows = props.data.map(row => [
            row.customerNo,
            row.meeterPointId,
            row.debtorName,
            row.utilityAddress,
            row.remainingTotal,
            asDateForExcel(row.regDate),
            getCurrentDate(),
        ]);

        // Smell header og data sammen
        const exportData = [headerRow, ...dataRows];

        // Convert the JSON data to a worksheet
        const ws = XLSX.utils.json_to_sheet(exportData);

        // Append the worksheet to the workbook with the desired sheet name
        XLSX.utils.book_append_sheet(wb, ws, props.filename || "Sheet1");

        // Write the workbook to a binary array
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

        // Create a Blob from the binary data and trigger a download
        saveAs(new Blob([wbout], { type: "application/octet-stream" }), getFileName());
    };
      
    return (
            <BfButtonBlue onClick={handleExport}>
                Excel valgte
            </BfButtonBlue>
    )
}

export default SelectedExcelSheet;